import { useMemo } from 'react';

import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';

import { EditRemoveBtn } from 'components/buttons';
import { PanelGrid } from 'components/grid';
import { Block } from 'components/page';
import { usePermissionsContext } from 'context/PermissionsContext';
import { useQueryPermissoes } from 'pages/cadastro/permissoes/hooks/useQueryPermissoes';
import { PermissoesProps } from 'pages/cadastro/permissoes/types';

/**
 * Retorna a lista de usuários para ser exibida na grid.
 */
const getRows = (data: PermissoesProps[] = []): GridRowsProp =>
    data.map((item) => ({
        id: item.idGrupoUsuario,
        idGrupoUsuario: item.idGrupoUsuario,
        dsGrupoUsuario: item.dsGrupoUsuario,
        dsObservacao: item.dsObservacao,
        dsGrupoEconomico: item.dsGrupoEconomico,
        fgPadraoFranqueado: item.fgPadraoFranqueado,
        fgAtivo: item.fgAtivo,
    }));

export function PermissoesGrid() {
    const { data, isFetching, refetch } = useQueryPermissoes();
    const { hasPermission } = usePermissionsContext();

    const columns = useMemo((): GridColDef[] => {
        const columns: GridColDef[] = [
            { field: 'idGrupoUsuario', headerName: 'Cód. Grupo Usuário', width: 140, minWidth: 130 },
            { field: 'dsGrupoUsuario', headerName: 'Grupo Usuário', flex: 1, minWidth: 110 },
            { field: 'dsObservacao', headerName: 'Observação', flex: 1, width: 100, minWidth: 90 },
            { field: 'dsGrupoEconomico', headerName: 'Grupo Econômico', flex: 1, width: 100, minWidth: 120 },
            { field: 'fgPadraoFranqueado', headerName: 'Padrão', minWidth: 140, type: 'boolean' },
            { field: 'fgAtivo', headerName: 'Grupo Ativo', minWidth: 100, type: 'boolean' },
        ];

        if (hasPermission(['GRUPO_PERMISSAO_ALTERAR'])) {
            columns.push({
                field: 'acoes',
                align: 'center',
                headerAlign: 'center',
                headerName: 'Ações',
                filterable: false,
                sortable: false,
                hideable: false,
                disableColumnMenu: true,
                minWidth: 80,
                renderCell: (params) => <EditRemoveBtn id={params.row.idGrupoUsuario} sx={{ p: 1.5 }} />,
            });
        }

        return columns;
    }, []);

    return (
        <Block>
            <PanelGrid rows={getRows(data?.data)} rowsCount={data?.total ?? 0} reload={refetch} loading={isFetching} columns={columns} />
        </Block>
    );
}
